import { Frame } from '@/scripts/libs/rox-lens-panel/types/RoxLensPanel'

interface PrescriptionAttribute {
  OD?: number
  OS?: number
}
interface PrescriptionAttributeForDirections {
  OD?: string
  OS?: string
}
export enum PrescriptionFlow {
  // eslint-disable-next-line no-unused-vars
  MANUAL = 'MANUAL',
  // eslint-disable-next-line no-unused-vars
  UPLOAD = 'UPLOAD',
}

export interface PrescriptionObject {
  prescriptionFlow: PrescriptionFlow
  prescriptionId?: number
  PD: PrescriptionAttribute
}

export interface ManualPrescriptionObject extends PrescriptionObject {
  SPH: PrescriptionAttribute
  CYL: PrescriptionAttribute
  AX: PrescriptionAttribute
  ADD: PrescriptionAttribute
  PRISM_ENABLED: boolean // Indicates whether prism checkbox is enabled/disabled
  VPRISM: PrescriptionAttribute
  VBASEDIR: PrescriptionAttributeForDirections
  HPRISM: PrescriptionAttribute
  HBASEDIR: PrescriptionAttributeForDirections
  COMMENT?: string // Optional comment
  issueDate?: string
  doctorName?: string // is this necessary?
}

export interface UploadPrescriptionObject extends PrescriptionObject {
  fileName: string
  fileSize: string
  fileData: string
  savedFileName: string
}

export interface IPrescriptionModule {
  prescriptionType: string
  prescriptionFlows: string[]
  fileExtensions: string[]
  maxFileSize: number
  hideMoreOptions: boolean
  enablePrismComment: boolean
  enablePrism: boolean
  checkPrescriptionIssueDate: number
  showdoctorName: boolean
  loadPrescription: () => Promise<ManualPrescriptionObject>
  savePrescription: (_prescriptionObject: ManualPrescriptionObject) => boolean
  checkAvailableFrames: (
    _frame: Frame,
    _prescriptionObject: ManualPrescriptionObject
  ) => string | null
  clearPrescription: () => boolean
  loadExtendedPrescription: () => Promise<PrescriptionObject | null>
  uploadExtendedPrescription: (
    _requestObject: UploadPrescriptionObject
  ) => Promise<UploadPrescriptionObject>
  saveExtendedPrescription: (
    _prescriptionObject: PrescriptionObject,
    _savedFileName?: string
  ) => Promise<PrescriptionObject>
  clearExtendedPrescription: () => Promise<Record<string, never>>
  downloadExtendedPrescription: (_savedFileName?: string) => Promise<UploadPrescriptionObject>
}
